<button
  type="{{ type }}"
  role="button"
  class="add-widget h3-bold size-{{ size }} user-name {{ color }}"
  [class.alert-link]="alert"
  [ngClass]="{ active: active === true, disabled: disabled === true }"
  aria-label="link button"
  (click)="custom_click.emit()">
  {{ label }}
  <app-ce-icon
    [name]="loading ? 'loader' : IconType"
    [svg_class]="['d-flex']"
    [size]="iconSize"
    [ngClass]="{ 'primary-50': active === false, 'loader-spin': loading }"></app-ce-icon>
  <ng-content></ng-content>
</button>
